import React, { FC } from "react";
import { useCurrencySymbol } from "hooks/useCurrencySymbol";
import { List } from "immutable";
import { useTranslation } from "react-i18next";
import formatter from "../../utils/formatter";
import {
  AddonIcon,
  IconCell,
  Price,
  Row,
  Title,
  Wrapper,
} from "./PackingOptionsList.styles";

interface PackingOptionsListProps {
  packing?: any;
  addonCodes?: any;
  consolidationAddons: any;
}

const PackingOptionsList: FC<PackingOptionsListProps> = ({
  packing,
  addonCodes,
  consolidationAddons,
}) => {
  const { t } = useTranslation("common");
  const currencySymbol = useCurrencySymbol();

  const getPriceTitle = (price: number) =>
    price > 0
      ? `${currencySymbol}${formatter.currency(price)}`
      : t("common.free", { currencySymbol });

  const renderRow = (
    key: string,
    iconUrl: string,
    title: string,
    priceTitle: string,
  ) => (
    <Row key={key}>
      <IconCell>{iconUrl ? <AddonIcon src={iconUrl} alt="" /> : null}</IconCell>
      <Title>{title}</Title>
      <Price>{priceTitle}</Price>
    </Row>
  );

  const selectedAddons = List()
    .concat(addonCodes || List())
    .map((code: any) =>
      consolidationAddons.find(
        (addon: any) => addon.get("code") === code || addon.get("id") === code,
      ),
    )
    .filter(Boolean);

  return (
    <Wrapper>
      {!!packing &&
        !!packing.size &&
        renderRow(
          "packing",
          packing.get("logo_url"),
          packing.get("title") || packing.get("description"),
          getPriceTitle(parseInt(packing.get("price_in_cents"), 10) / 100),
        )}
      {selectedAddons.map((addon: any, index: number) =>
        renderRow(
          `addon-${addon.get("id")}-${index}`,
          addon.get("icon_url"),
          addon.get("description"),
          getPriceTitle(parseFloat(addon.get("price"))),
        ),
      )}
    </Wrapper>
  );
};

export default React.memo(PackingOptionsList);
